import React from 'react';
import { SpeechSpeed, SPEECH_SPEED_LABELS } from '../../../types/annotation';

interface SpeechSpeedSelectorProps {
  value: SpeechSpeed | null;
  onChange: (v: SpeechSpeed) => void;
  disabled?: boolean;
}

const SPEED_ORDER: SpeechSpeed[] = ['slow', 'normal', 'fast', 'very_fast'];

const SpeechSpeedSelector: React.FC<SpeechSpeedSelectorProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  return (
    <div className="flex gap-2">
      {SPEED_ORDER.map((speed) => {
        const isSelected = value === speed;
        return (
          <label
            key={speed}
            className={[
              'flex-1 flex items-center justify-center gap-1.5 px-2 py-1.5 rounded-lg border text-xs font-medium cursor-pointer transition-colors',
              isSelected
                ? 'bg-violet-600 border-violet-600 text-white'
                : 'bg-white border-gray-200 text-gray-600 hover:bg-gray-50',
              disabled ? 'opacity-50 cursor-not-allowed' : '',
            ].join(' ')}
          >
            <input
              type="radio"
              name="speech-speed"
              value={speed}
              checked={isSelected}
              onChange={() => onChange(speed)}
              disabled={disabled}
              className="sr-only"
            />
            {SPEECH_SPEED_LABELS[speed]}
          </label>
        );
      })}
    </div>
  );
};

export default SpeechSpeedSelector;
